import {Buffer} from 'buffer';

/**
 * Strip EXIF data from given Buffer image data
 *
 * If the given Buffer is not from a JPEG image, return the same buffer.
 *
 * @param imageBuffer A Buffer that represents the image that will be stripped of EXIF data
 * @return A Buffer that represents the input image now stripped of EXIF data
 */
export default function stripExifData(imageBuffer: Buffer): Buffer {
  // Check for JPEG SOI marker
  if (imageBuffer[0] !== 0xff || imageBuffer[1] !== 0xd8) {
    // Not a valid JPEG image
    return imageBuffer;
  }

  let offset = 2;
  const length = imageBuffer.length;
  const outputBuffer = Buffer.alloc(length);
  let outputOffset = 0;

  // Copy SOI marker
  imageBuffer.copy(outputBuffer, outputOffset, 0, offset);
  outputOffset += offset;

  while (offset < length) {
    // Check for EXIF APP1 marker
    if (imageBuffer[offset] === 0xff && imageBuffer[offset + 1] === 0xe1) {
      // Skip EXIF data
      const segmentLength = imageBuffer.readUInt16BE(offset + 2);
      offset += 2 + segmentLength;
    } else if (imageBuffer[offset] === 0xff && imageBuffer[offset + 1] === 0xd9) {
      // Copy EOI marker
      imageBuffer.copy(outputBuffer, outputOffset, offset, offset + 2);
      outputOffset += 2;
      offset += 2;
    } else {
      // Copy non-EXIF segment
      const segmentLength = imageBuffer[offset] === 0xff ? 2 + imageBuffer.readUInt16BE(offset + 2) : 1;
      imageBuffer.copy(outputBuffer, outputOffset, offset, offset + segmentLength);
      outputOffset += segmentLength;
      offset += segmentLength;
    }
  }

  // Trim output buffer to actual size
  const returnBuffer = outputBuffer.slice(0, outputOffset);
  return returnBuffer;
}
